export default __webpack_public_path__ + "static/2073-1c283c9324d3c53e790426df9311ea96.gif";